// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function File(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "File" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3V21H19V7L14 3H5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=File.js.map